import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/MachineMaintenanceSummaryListActions";
import * as api from "../../api/MachineMaintenanceSummaryListApi";
import { showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getAreaGroupList({ payload }) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getAreaGroupList(payload);
        yield put(actions.setAreaGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setAreaGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMainEquipmentList({ payload }) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getMainEquipmentList(payload);
        yield put(actions.setMainEquipmentList(data || undefined));
    } catch (error) {
        yield put(actions.setMainEquipmentList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSubEquipmentList({ payload }) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getSubEquipmentList(payload);
        yield put(actions.setSubEquipmentList(data || undefined));
    } catch (error) {
        yield put(actions.setSubEquipmentList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSubEquipmentsTaskList({ payload }) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getSubEquipmentsTaskList(payload);
        yield put(actions.setSubEquipmentsTaskList(data || undefined));
    } catch (error) {
        yield put(actions.setSubEquipmentsTaskList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownReasonGroupData() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getBreakdownReasonGroupData();
        yield put(actions.setBreakdownReasonGroupData(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownReasonPlaceData() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getBreakdownReasonPlaceData();
        yield put(actions.setBreakdownReasonPlaceData(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownEffectData() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getBreakdownEffectData();
        yield put(actions.setBreakdownEffectData(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownRootCauseData() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getBreakdownRootCauseData();
        yield put(actions.setBreakdownRootCauseData(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPoolData() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPoolData();
        yield put(actions.setPoolData(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_AREA_GROUP_LIST, getAreaGroupList);
    yield takeEvery(actions.Types.GET_MAIN_EQUIPMENT_LIST, getMainEquipmentList);
    yield takeEvery(actions.Types.GET_SUB_EQUIPMENT_LIST, getSubEquipmentList);
    yield takeEvery(actions.Types.GET_SUB_EQUIPMENTS_TASK_LIST, getSubEquipmentsTaskList);
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_GROUP_DATA, getBreakDownReasonGroupData);
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_PLACE_DATA, getBreakDownReasonPlaceData);
    yield takeEvery(actions.Types.GET_BREAKDOWN_EFFECT_DATA, getBreakDownEffectData);
    yield takeEvery(actions.Types.GET_BREAKDOWN_ROOT_CAUSE_DATA, getBreakdownRootCauseData);
    yield takeEvery(actions.Types.GET_POOL_DATA, getPoolData);
}

const MachineMaintenanceSummaryListSaga = [fork(watchAll)];

export default MachineMaintenanceSummaryListSaga;
